import { Modal } from 'antd'
import CustomButton from 'components/atoms/custom-button'
import { xenditBankList } from 'constant'

const XenditBanksModal = ({
  open,
  selectedBank,
  handleNext,
  handleSelectedBank,
  onClose,
  isSubmitLoading = false
}) => {
  return (
    <Modal
      className="lg:w-[552px] w-full "
      open={open}
      // title={<h2 className="text-primary text-2xl font-normal">Set Medhurst Group as Sold</h2>}
      title={<h2 className="text-primary text-2xl font-normal">Pilih Metode Pembayaran</h2>}
      footer=""
      centered
      closable={false}
      maskClosable={false}>
      <div className="space-y-6">
        <div className="space-y-4">
          <p className="text-primary font-medium">Transfer Virtual Account</p>
          <div className="h-[300px] hidden-scrollbar flex flex-col overflow-y-auto gap-2">
            {xenditBankList.map((item, index) => (
              <div
                key={`bank-${index + 1}`}
                className={`py-3 border-b border-x-0 border-t-0 border-solid cursor-pointer border-lighter flex justify-between w-full`}
                onClick={() => handleSelectedBank(item)}>
                <div className="flex gap-4 item-center">
                  <div className="w-[56px] h-[24px] shrink-0 grow-0">
                    <img
                      src={item.image}
                      alt={`bank-${index + 1}`}
                      className="object-contain h-full w-full"
                    />
                  </div>
                  <span className="text-primary font-medium">{item.label}</span>
                </div>
                <div
                  className={`h-5 w-5 rounded-full border border-solid ${
                    selectedBank?.value === item.value ? 'border-brand-default' : 'border-lighter'
                  } shrink-0 grow-0 flex items-center justify-center`}>
                  <div
                    className={`h-2 w-2 shrink-0 grow-0 rounded-full ${
                      selectedBank?.value === item.value ? 'bg-brand-default' : 'bg-transparent'
                    }`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-4 justify-end">
          <CustomButton disabled={isSubmitLoading} type="plain" onClick={onClose}>
            Batal
          </CustomButton>
          <CustomButton onClick={handleNext} isLoading={isSubmitLoading} disabled={!selectedBank}>
            Pilih
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default XenditBanksModal
